export const CHART_COLORS = {
    blue: '#27A5DF',
    blueDark: '#1F6FA1',
    green: '#16A73F',
    orange: '#EA9D0F',
    red: '#FF645F',
    grey: '#889FB4',
    slate: '#5B6472'
} as const;

export const CHART_AVERAGE_COLOR = CHART_COLORS.slate;
